import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import type { CustomRouteComponentProps } from 'react-router-dom';
import { compose } from 'redux';

import type { RootState } from 'af-reducers';

import Breadcrumbs from 'af-components/Breadcrumbs';

import CLIENT from 'af-routes/client';

import * as JobTemplateActions from 'af-actions/jobTracking';

import FormModel from '../Shared/formModel';
import JobTrackingForm from '../Shared/JobTrackingForm';

interface CompanySettingsRouteProps {
	orgAlias: string;
	companyName: string;
}

type OwnProps = CustomRouteComponentProps<CompanySettingsRouteProps>;

type Props = OwnProps & ConnectedProps<typeof connector>;

const CreateJobTrackingTemplateForm: React.FC<Props> = (props: Props) => {

	const {
		company,
		create,
	} = props;

	const history = useHistory();
	const location = useLocation<{ orgAlias: string; }>();

	const createTemplate = React.useCallback(async (template: FormModel) => {
		await create(FormModel.toCreateRM(template));
		history.push(CLIENT.COMPANY.SETTINGS.JOB_TRACKING_TEMPLATES.ROOT(location.state.orgAlias, company.name));
	}, [company.name, create, history, location.state.orgAlias]);

	const goToTemplates = React.useCallback(() => {
		history.push(CLIENT.COMPANY.SETTINGS.JOB_TRACKING_TEMPLATES.ROOT(location.state.orgAlias, company.name));
	}, [company.name, history, location.state.orgAlias]);

	return (
		<div className="form-segment">
			<Breadcrumbs items={[{ label: 'Job Tracking Templates', onClick: goToTemplates }, { label: 'New Template' }]} />
			<JobTrackingForm isEdit={false} onSubmit={createTemplate} />
		</div>
	);
};

function mapStateToProps(state: RootState) {
	const { companyData } = state.user;

	if (!companyData) {
		throw new Error('User not logged in');
	}

	return {
		company: companyData,
	};
}

function mapDispatchToProps() {
	return {
		create: JobTemplateActions.createTemplate,
	};
}

const connector = connect(mapStateToProps, mapDispatchToProps());

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(CreateJobTrackingTemplateForm);
